import React from "react";

import { Edit, Trash2 } from "lucide-react";
import { Checkbox } from "../ui/checkbox";
import { Member } from "@/types/project";
import { useDeleteProjectMember } from "@/api/ProjetsApi";
import { formatDate } from "@/utils/helpers";
import SmallLoader from "../SmallLoader";

interface ProjectMemberRowProps {
  member: Member;
  isChecked: boolean;
  onToggle: (id: string, checked: boolean) => void;
}

const ProjectMemberRow: React.FC<ProjectMemberRowProps> = ({
  member,
  isChecked,
  onToggle,
}) => {
  const { deleteProjectMember, loading } = useDeleteProjectMember();

  const handleDelete = async (currentMember: Member) => {
    // Handle delete action here
    await deleteProjectMember(currentMember);
  };

  return (
    <div className="grid grid-cols-[400px_2fr_2fr_.5fr] p-4 border-b transition">
      <div className="flex items-center space-x-4 ">
        <Checkbox
          checked={isChecked}
          onCheckedChange={(checked) => onToggle(member.id, checked as boolean)}
        />
        <img
          src={
            member.profilePictureUrl
              ? member.profilePictureUrl
              : "/images/user.png"
          }
          className="w-12 h-12 rounded-full "
        />
        <div>
          <p className="text-gray-800 font-medium">{member.username}</p>
          <p className="text-gray-500 text-sm">{member.email}</p>
        </div>
      </div>
      <div className="text-sm text-gray-500">
        <p>{formatDate(member?.addedDate || "")}</p>
      </div>
      <div className="text-sm text-gray-500">
        <p>{formatDate(member?.lastActivityDate || "")}</p>
      </div>
      <div className="flex items-center space-x-4 justify-center">
        {loading ? (
          <SmallLoader />
        ) : (
          <>
            <button
              onClick={() => {}}
              className="text-gray-500 hover:text-gray-700"
            >
              <Edit />
            </button>
            <button
              onClick={() => handleDelete(member)}
              className="text-red-500 hover:text-red-700"
            >
              <Trash2 className="text-red " />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ProjectMemberRow;
